<template>
  <div class="card w-100 mt-3" v-on:click="selectServicekleber()">
    <div class="card-body">
      <h5 class="card-title">
        {{
          servicekleber.tib.name == servicekleber.tib.name
            ? servicekleber.tib.name
            : servicekleber.tib.name + " " + servicekleber.data.extRef
        }}
      </h5>
      <div class="md" v-html="markedHtml(servicekleber.data.description)"></div>
    </div>
  </div>
</template>

<script>
import { markedHtml } from "@/common/utils";
export default {
  name: "servicekleberItem",
  data() {
    return {
      servicekleber: this.servicekleberProperty,
      markedHtml: markedHtml
    };
  },
  watch: {
    servicekleberProperty() {
      this.servicekleber = this.servicekleberProperty;
    }
  },
  methods: {
    selectServicekleber() {
      console.info("emit:selectservicekleber");
      this.$emit("selectservicekleber", this.servicekleber);
    }
  },
  props: ["servicekleberProperty"]
};
</script>
